<script setup>
// Inspector do nó "Transcrição" (FlexCalls). Estar no fluxo já entrega a
// transcrição como nota interna na conversa (Flexcalls::DeliveryPolicy checa
// a presença do nó). O único campo é "summary": pede um resumo da ligação
// junto da transcrição, em vez do texto bruto inteiro.
//
// RULING 1: summary tem que sair como booleano de verdade, nunca string — o
// backend faz ActiveModel::Type::Boolean.cast, mas "false" (string) é truthy
// em Ruby e ligaria o resumo escondido. $event.target.checked já é boolean
// nativo do DOM; não converter para string em nenhum passo daqui.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({ data: { type: Object, required: true } });
const emit = defineEmits(['update', 'remove', 'close']);
const { t } = useI18n();

const summary = computed(() => props.data.summary === true);
</script>

<template>
  <div class="p-4">
    <div class="mb-3 flex items-center justify-between">
      <div class="flex items-center gap-2.5">
        <span
          class="flex size-8 shrink-0 items-center justify-center rounded-xl bg-n-brand/15 text-n-brand"
        >
          <span class="i-lucide-file-text text-base" />
        </span>
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ data.label || t('AI_AGENTS.FLOW.FLEXCALLS.TRANSCRIPT_TITLE') }}
        </h3>
      </div>
      <button class="i-lucide-x text-n-slate-10" @click="emit('close')" />
    </div>

    <p class="mb-3 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.FLEXCALLS.TRANSCRIPT_DESCRIPTION') }}
    </p>

    <div
      class="mb-3 flex items-start gap-2 rounded-lg border border-n-teal-6 bg-n-teal-2 px-3 py-2 text-xs text-n-teal-11"
    >
      <span class="i-lucide-lock mt-0.5 shrink-0" />
      <span>{{ t('AI_AGENTS.FLOW.FLEXCALLS.TRANSCRIPT_NOTE') }}</span>
    </div>

    <label
      class="flex cursor-pointer items-center justify-between rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2.5"
    >
      <span class="min-w-0">
        <span class="block text-sm font-medium text-n-slate-12">
          {{ t('AI_AGENTS.FLOW.FLEXCALLS.TRANSCRIPT_SUMMARY') }}
        </span>
        <span class="block text-[11px] leading-tight text-n-slate-10">
          {{ t('AI_AGENTS.FLOW.FLEXCALLS.TRANSCRIPT_SUMMARY_HINT') }}
        </span>
      </span>
      <input
        type="checkbox"
        data-testid="flexcalls-transcript-summary"
        class="size-4 shrink-0 accent-n-brand"
        :checked="summary"
        @change="emit('update', { summary: $event.target.checked })"
      />
    </label>

    <button
      class="mt-4 w-full rounded-lg border border-n-ruby-7 py-2 text-sm font-medium text-n-ruby-9 hover:bg-n-ruby-3"
      @click="emit('remove')"
    >
      {{ t('AI_AGENTS.FLOW.REMOVE_NODE') }}
    </button>
  </div>
</template>
